$(document).ready(function(){
	$('.gallery').slick({
	  infinite: true,
	  fade: true,
	  arrows: false,
	  asNavFor: '.choice-btn',
	});
	$('.choice-btn').slick({
	  infinite: true,
	  slidesToShow: 3.1,
	  focusOnSelect: true,
	  prevArrow: '<div class="slick-prev"></div>',
	  nextArrow: '<div class="slick-next"></div>',
	  asNavFor: '.gallery',
	});
	
	//アコーディオン
	$('.acdn dt').click(function(){
		$(this).toggleClass("is-open");
		$(this).next('dd').slideToggle(300);
		
	});	
	
	$('.showroom_menu a[href^="#"]').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		//var headerHeight = $('#header').height();
		var position = target.offset().top;
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
		
	});

  $('.menu-child-showroom ul li a,.mobile-nav .mobile-nav .mobile-nav__item a.mobile-nav__link').click(function(){
          location.href= $(this).attr('href');
          location.reload(true);
	});

	$(window).on("load", function() {
		var hash = location.hash;
		if(hash){
			var target = $(hash);
			var position = target.offset().top - headerHeight;
			$("html, body").animate({scrollTop:position}, 0, "swing");
		}
	});
	
	$(".showroom_menu").css({
		"left": $('.header__wrapper').offset().left ,
		
		//"top": $('#showroom .intro_txt').offset().top
	});

	size();
	$(window).on("resize", function() {size();});
	function size() {
		if (window.matchMedia( "(min-width: 741px)" ).matches) {
			var menu_height = $('.showroom_menu').outerHeight();
			var intro_txt = $('.intro_txt').outerHeight();
			$(".showroom_menu").css({
				"margin-top": - intro_txt,
                "top": headerHeight
			})
			$(".showroom_block:first-of-type").css({
				"margin-top": intro_txt - menu_height
			})
		}
	}
});